"use client";

import React, { useState } from "react";
import { Leaf, Key, Sparkles, Wrench, House, BellRing, Check, ChevronDown, ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
const services = [{
  id: "visti-business",
  title: "Visti per Affari e Lavoro",
  iconName: "Key",
  description: "Assistenza dedicata per aziende, professionisti e mobilità internazionale del personale, con gestione delle procedure consolari e documentali per trasferimenti e attività lavorative internazionali."
}, {
  id: "compliance-aziendale",
  title: "Compliance e Audit",
  iconName: "Sparkles",
  description: "Supporto professionale per aziende nella gestione documentale e amministrativa legata alla mobilità internazionale e all’impiego di personale estero."
}, {
  id: "mobilita-globale",
  title: "Mobilità Internazionale",
  iconName: "Leaf",
  description: "Coordinamento strategico per la mobilità globale dei talenti, garantendo una transizione fluida e conforme alle normative internazionali."
}];
const serviceDetails = [{
  serviceId: "visti-business",
  detail: "Visti per Affari"
}, {
  serviceId: "visti-business",
  detail: "Visti per Lavoro"
}, {
  serviceId: "visti-business",
  detail: "Trasferimenti Intra-Societari (ICT)"
}, {
  serviceId: "visti-business",
  detail: "Distacco Internazionale Dipendenti"
}, {
  serviceId: "visti-business",
  detail: "EU Blue Card"
}, {
  serviceId: "visti-business",
  detail: "Visti per Investitori e Start-Up"
}, {
  serviceId: "visti-business",
  detail: "Nulla Osta al Lavoro"
}, {
  serviceId: "visti-business",
  detail: "Permessi di Soggiorno Aziendali"
}, {
  serviceId: "visti-business",
  detail: "Mobilità Internazionale Manageriale"
}, {
  serviceId: "compliance-aziendale",
  detail: "Audit preventivi per prevenire sanzioni amministrative"
}, {
  serviceId: "compliance-aziendale",
  detail: "Formazione HR su procedure di assunzione stranieri"
}, {
  serviceId: "compliance-aziendale",
  detail: "Verifica Documentazione Internazionale"
}, {
  serviceId: "compliance-aziendale",
  detail: "Assistenza Procedure Amministrative"
}, {
  serviceId: "compliance-aziendale",
  detail: "Supporto Assunzione Personale Estero"
}, {
  serviceId: "compliance-aziendale",
  detail: "Gestione Scadenze Documentali"
}, {
  serviceId: "compliance-aziendale",
  detail: "Supporto HR Mobilità Internazionale"
}, {
  serviceId: "mobilita-globale",
  detail: "Mobilità Internazionale Aziendale"
}, {
  serviceId: "mobilita-globale",
  detail: "Coordinamento Trasferimenti Internazionali"
}, {
  serviceId: "mobilita-globale",
  detail: "Supporto Espansione Aziendale Estero"
}, {
  serviceId: "mobilita-globale",
  detail: "Strategie di Espansione del Capitale Umano all’Estero"
}, {
  serviceId: "mobilita-globale",
  detail: "Ottimizzazione dei Flussi Migratori per Progetti Globali"
}, {
  serviceId: "mobilita-globale",
  detail: "Assistenza Trasferte Professionali"
}, {
  serviceId: "mobilita-globale",
  detail: "Gestione Documentazione Internazionale"
}, {
  serviceId: "mobilita-globale",
  detail: "Supporto Consolare Aziendale"
}, {
  serviceId: "mobilita-globale",
  detail: "Assistenza Multi-Paese"
}, {
  serviceId: "mobilita-globale",
  detail: "Accoglienza Executive e Soluzioni Abitative"
}, {
  serviceId: "mobilita-globale",
  detail: "Supporto per Integrazione Familiare e Scolastica"
}, {
  serviceId: "mobilita-globale",
  detail: "Gestione Logistica per Figure Apicali"
}, {
  serviceId: "mobilita-globale",
  detail: "Alert Scadenze e Rinnovi Permessi Aziendali"
}];
const iconMap: Record<string, React.ElementType> = {
  Leaf,
  Key,
  Sparkles,
  Wrench,
  House,
  BellRing
};
export default function ServicesAuxProprietaires() {
  const [expandedIds, setExpandedIds] = useState<string[]>([]);
  const toggleExpand = (id: string) => {
    setExpandedIds(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
  };
  return <section data-section-id="222238" id="soluzioni-per-il-business" className="bg-muted/30 text-foreground py-20 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 max-w-3xl text-center mx-auto">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6 tracking-tight">
            Soluzioni per il Business
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Supportiamo le aziende nella gestione della mobilità globale con un approccio diplomatico e d'eccellenza. 
            Garantiamo conformità normativa e fluidità operativa per i vostri talenti internazionali.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
          const Icon = iconMap[service.iconName];
          const details = serviceDetails.filter(d => d.serviceId === service.id);
          const isExpanded = expandedIds.includes(service.id);
          return <div key={service.id} data-index={index}>
                <Card className={cn("h-full border-primary/20 shadow-lg hover:shadow-xl hover:border-secondary/50 transition-all duration-500 bg-primary overflow-hidden rounded-2xl cursor-pointer group py-0", isExpanded && "ring-1 ring-secondary/30")} onClick={() => toggleExpand(service.id)} onKeyDown={e => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                toggleExpand(service.id);
              }
            }} tabIndex={0} aria-expanded={isExpanded}>
                  <div className="p-6 md:p-7">
                    <div className="flex items-start justify-between gap-4 mb-6">
                      <div className="flex items-center justify-center gap-5 text-center w-full">
                        <div className="p-3.5 rounded-xl border border-secondary/30 bg-gradient-to-br from-secondary/20 to-secondary/10 text-secondary shrink-0 shadow-sm group-hover:scale-110 transition-transform duration-300">
                          <Icon className="size-6 stroke-[1.5]" />
                        </div>
                        <h3 className="font-serif text-xl font-bold text-primary-foreground tracking-tight leading-tight">
                          {service.title}
                        </h3>
                      </div>
                      <div className={cn("mt-2 p-1 rounded-full bg-white/10 text-primary-foreground/70 transition-transform duration-300", isExpanded && "rotate-180 bg-secondary/20 text-secondary")}>
                        <ChevronDown className="size-5" />
                      </div>
                    </div>

                    <div className="space-y-4">
                      {service.description && <p className={cn("text-base text-primary-foreground/80 font-sans leading-relaxed transition-all duration-300 text-center", "")}>
                          {service.description}
                        </p>}

                      <Button variant="ghost" className="p-0 h-auto text-secondary hover:text-secondary/80 hover:bg-transparent font-semibold flex items-center gap-2 group/btn" onClick={e => {
                    e.stopPropagation();
                    toggleExpand(service.id);
                  }}>
                        Scopri tutti i servizi
                        <ChevronDown className={cn("size-4 transition-transform duration-300", isExpanded && "rotate-180")} />
                      </Button>
                      
                      <div className={cn("grid transition-all duration-500 ease-in-out overflow-hidden", isExpanded ? "grid-rows-[1fr] opacity-100 mt-6" : "grid-rows-[0fr] opacity-0")}>
                        <ul className="min-h-0 space-y-3.5 border-t border-white/10 pt-6">
                          {details.map((item, detailIndex) => <li key={detailIndex} data-index={detailIndex} className="flex items-start gap-3 text-primary-foreground/90 group/item">
                              <div className="mt-1 bg-secondary/20 rounded-lg p-0.5">
                                <ArrowRight className="size-4 text-secondary shrink-0" />
                              </div>
                              <span className="text-sm font-sans leading-relaxed group-hover/item:text-secondary transition-colors duration-200">
                                {item.detail}
                              </span>
                            </li>)}
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}